
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import UpdateBackOrderStatu from '@/store/entities/back-updatestatus'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import user from '@/store/entities/userinfo'
    import QRcode from 'qrcodejs2'
    @Component
    export default class EditLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        updateData: UpdateBackOrderStatu = new UpdateBackOrderStatu();
        buttonName: string = '';
        imgUploadUrl: string = '';
        abnormalImageUploadGuid: string = "";
        imgUrl: string = "";
        isShowUserList: boolean = false;

        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        selectuser: user = new user();
        user: Array<user> = [];
        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
            this.getUser();
        }

        async getUser() {
            this.user = await this.$store.dispatch({
                type: 'user/getUserList',
                data: {}
            });
            if (this.user.length > 0) {
                var data = this.user.filter(function (item) { return item.id == abp.session.userId });
                if (data.length > 0) {
                    this.selectuser.id = data[0].id;
                }
            }

        }
        setQrCode(val: string) {
            let qrcode = new QRcode('Cqrcode', {
                width: 150,
                height: 150, // 高度
                text: window.location.origin + "/#/takephone/abnormalphoto?orderNumber=" + val, // 二维码内容
            });
        }

        handleSuccess(res, file) {
            if (res.success) {
                this.updateData.abnormalImageUploadGuid = res.result;
                this.setImage();
            }
        }
        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }
        async save() {
            if (this.updateData.orderStatus == -1 && this.selectuser == null) {
                this.$Message.error('请选择对应业务员。');
                return;
            }
            this.updateData.salesmanId = this.selectuser.id;
            await this.$store.dispatch({
                type: 'backstockorder/procesOrderStatu',
                data: this.updateData
            });
            (this.$refs.updateform as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
            document.getElementById('Cqrcode').innerHTML = "";
        }
        setImage() {
            if (this.updateData.abnormalImageUploadGuid && this.updateData.abnormalImageUploadGuid.length > 1) {
                var data = { imageGuid: this.updateData.abnormalImageUploadGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            } else {
                this.imgUrl = null;
            }
        }
        cancel() {
            (this.$refs.updateform as any).resetFields();
            this.$emit('input', false);
            document.getElementById('Cqrcode').innerHTML = "";
        }
        visibleChange(value: boolean) {
            document.getElementById('Cqrcode').innerHTML = "";
            if (!value) {
                this.$emit('input', value);
            } else {
                this.updateData = Util.extend(true, {}, this.$store.state.backstockorder.updateOrdeData);
                var orderStatus = this.updateData.orderStatus;
                this.setImage();
                this.buttonName = "标记为" + Enums.WarehouseOrderStatus.filter(function (item) { return item.value == orderStatus })[0].name;
                if (orderStatus == -1) {
                    this.isShowUserList = true;
                } else {
                    this.isShowUserList = false;
                }
                this.setImage();
                this.setQrCode(this.updateData.orderNumber);
            }
        }
    }
